export default {
    paletteFooter: {
        backgroundColor: "white",
        height: "5vh",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center;font-weight: bold"
    },
    emoji: {
        fontSize: "1.5rem",
        margin: "0 1rem"
    }
}